import styled from 'styled-components';

interface IModalProps {
  severidade?: number;
}

export const Container = styled.div`
  display: grid;
  place-items: center;
  z-index: 1999;
  width: 100vw;
  height: 100vh;
  position: fixed;
  inset: 0;
  background: rgba(14, 14, 14, 0.3);
  padding: 24px;
`;

const getHeaderBackground = (severidade?: number) => {
  switch (severidade) {
    case 1:
      return '#E6B800';
    case 2:
      return '#FF0000';
    case 3:
      return '#2ECC71';
    default:
      return '#b10000';
  }
};

const getIconColor = (severidade?: number) => {
  switch (severidade) {
    case 1:
      return '#ffffff';
    case 2:
      return '#E6B800';
    case 3:
      return '#ffffff';
    default:
      return '#E6B800';
  }
};

export const ModalMessage = styled.div<IModalProps>`
  width: min(560px, 95vw);
  min-height: 600px;
  max-height: calc(100vh - 48px);
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: column;

  .contentWrapper {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: stretch;
  }

  .content {
    width: 100%;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 0;
    background: transparent;
    color: #fff;
    cursor: pointer;

    display: grid;
    place-items: center;
    font-size: 22px;
    line-height: 1;

    transition: background 0.15s ease;
    z-index: 3;
  }

  .close:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .top {
    width: 100%;
    background: ${({ severidade }) => getHeaderBackground(severidade)};
    padding: 14px 18px 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .titleRow {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .icon {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      color: ${({ severidade }) => getIconColor(severidade)};
    }

    .titleBox {
      padding: 0; /* pra não “empurrar” */
      line-height: 1.2;
    }
  }

  .titleBox {
    width: min(360px, 86%);
    border-radius: 2px;
    padding: 10px 14px;
    text-align: center;
    font-weight: 800;
    font-size: 22px;
    color: #fff;
  }

  .stripe {
    width: 100%;
    height: 10px;
  }

  .body {
    width: 100%;
    padding: 16px 22px 18px;
    color: #2a2a2a;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.45;

    flex: 1;
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .body p {
    margin: 10px 0;
  }

  .actions {
    width: 100%;
    padding: 12px 16px 16px;

    display: flex;
    justify-content: center;
    gap: 32px;

    /* border-top: 1px solid #e0e0e0; */
  }

  .checkbox {
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 13px;
    font-weight: 600;
    color: #444;

    cursor: pointer;
    user-select: none;
  }

  .checkbox input {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .footerRed {
    width: 100%;
    color: #6c7293;
    text-align: center;
    padding: 13px 10px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.25;
    border-top: 1px solid #6c7293;
  }

  .footerBlack {
    width: 100%;
    background: #0b0b0b;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footerBlack img,
  .footerBlack svg {
    height: 26px;
    display: block;
  }

  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    width: 38px;
    height: 38px;
    border-radius: 10px;
    border: 0;

    color: rgba(0, 0, 0, 0.55);
    font-size: 46px;
    cursor: pointer;

    display: grid;
    place-items: center;

    z-index: 3;
    user-select: none;

    transition: opacity 0.2s ease, transform 0.15s ease, background 0.15s ease;
  }

  /* .arrow:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.7);
    transform: translateY(-50%) scale(1.05);
  } */

  .arrow.left {
    left: -10px;
  }

  .arrow.right {
    right: -10px;
  }

  .arrow:disabled {
    opacity: 0.25;
    cursor: default;
    transform: translateY(-50%);
  }

  @media (max-width: 480px) {
    min-height: 520px;

    .arrow {
      width: 34px;
      height: 34px;
      font-size: 22px;
      border-radius: 10px;
    }

    .arrow.left {
      left: -12px;
    }

    .arrow.right {
      right: -12px;
    }

    .body {
      padding: 14px 14px 16px;
    }
  }
`;
